import { Box, Paper, IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { getLeads } from "../../api/api";
import { useNavigate } from "react-router-dom";

import DataTable from "../../components/datatable/DataTable";
import FilterBar from "../../components/common/FilterBar";
import StatusChip from "../../components/datatable/StatusChip";

import VisibilityIcon from "@mui/icons-material/Visibility";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { showSnackbar } from "../../store/snackbarSlice";

import { GridColDef } from "@mui/x-data-grid";
import { useDispatch } from "react-redux";

const CreditList = () => {
  const [data, setData] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [status, setStatus] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);

      let finalStatus = "credit,approved,disbursed";

      // 🔥 custom filter
      if (status) {
        finalStatus = status;
      }

      const res = await getLeads({
        search,
        status: finalStatus,
      });

      setData(res.data?.data || []);
    } catch {
      dispatch(
        showSnackbar({
          message: "Failed to fetch credit leads",

          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delay = setTimeout(fetchData, 400);

    return () => clearTimeout(delay);
  }, [search, status]);

  const columns: GridColDef[] = [
    {
      field: "leadCode",
      headerName: "Lead ID",
      flex: 1,
      renderCell: (params) => params.value || "-",
    },
    { field: "customerName", headerName: "Customer", flex: 1 },
    { field: "mobile", headerName: "Mobile", flex: 1 },
    {
      field: "productType",
      headerName: "Product",
      flex: 1,
      renderCell: (params) => (
        <span style={{ textTransform: "capitalize" }}>{params.value}</span>
      ),
    },
    {
      field: "pendingReason",
      headerName: "Pending Reason",
      flex: 1.5,
      renderCell: (params) => (params.value ? params.value : "-"),
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => <StatusChip status={params.value} />,
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;

        return (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {/* CREDIT */}
            <Tooltip
              title={row.status === "credit" ? "Open Credit" : "View Credit"}
            >
              <IconButton
                size="small"
                onClick={() =>
                  navigate(
                    row.status === "credit"
                      ? `/credit/create/${row._id}`
                      : `/credit/view/${row._id}`,
                  )
                }
              >
                <VisibilityIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            {/* LOAN */}
            {row.status === "approved" && row.loanId && (
              <Tooltip title="Open Disbursement">
                <IconButton
                  size="small"
                  onClick={() => navigate(`/disbursement/create/${row.loanId}`)}
                  sx={{
                    background: "#dcfce7",
                    color: "#16a34a",
                  }}
                >
                  <AccountBalanceIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ p: 1 }}>
      <FilterBar
        title="Credit Management"
        search={search}
        onSearchChange={setSearch}
        status={status}
        onStatusChange={setStatus}
      />

      <Paper
        sx={{
          mt: 2,
          borderRadius: "16px",
          overflow: "hidden",
          border: "1px solid #e2e8f0",
        }}
      >
        <DataTable rows={data} columns={columns} loading={loading} />
      </Paper>
    </Box>
  );
};

export default CreditList;
